import React from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import Typography from "@components/Typography";
// import TextField from "@components/TextField";
import Button from "@components/Button";
import { InputAdornment, TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}
const PriceTextField = ({
  name,
  text,
  currencyName,
  handleChange,
  register,
  error,
  value,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <TextField
      fullWidth
      name={name}
      size="small"
      variant="outlined"
      onChange={handleChange}
      inputRef={register}
      value={value}
      className={classes.inputBase}
      error={error}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="end">
            <Typography variant="3xs" color="secondary.main" isBold>
              {text}
            </Typography>
          </InputAdornment>
        ),
        inputComponent: NumberFormatCustom,
        endAdornment: (
          <Button
            variant="contained"
            size="small"
            disabled
            className={classes.Button}
          >
            <Typography variant="3xs" color="secondary.tint40" isBold>
              {currencyName}
            </Typography>
          </Button>
        ),
      }}
    />
  );
};

export default PriceTextField;
